import React, { useState, useEffect, useRef } from 'react';
import './ProgramDetails.css';
import { useNavigate } from 'react-router-dom';
import { initFacebookPixel } from '../facebookPixel';
const ProgramDetails = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoSlidePaused, setIsAutoSlidePaused] = useState(false);
  const navigate = useNavigate();
  const sliderRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const sliderData = [
    {
        imgSrc: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/sb1.png',
        title: 'Access to Multiple Facilities',
        description: 'Enjoy unlimited access to all Machaxi centers, allowing you to choose the most convenient location. Experience a variety of swimming environments designed for both training and leisure.',
    },
    {
        imgSrc: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/flexibles.jpg',
        title: 'Flexible Scheduling',
        description: 'Book and enjoy swim sessions at your preferred time with friends and family. Flexible scheduling options to seamlessly fit into your lifestyle.',
    },
    {
        imgSrc: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/rewardp.jpg',
        title: 'Reward Programs',
        description: 'Earn exclusive rewards for every hour spent in a Machaxi swimming pool. Redeem points for exciting benefits, including discounts on sessions and merchandise.',
    },
    {
        imgSrc: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/sb5.png',
        title: 'State-of-the-Art Facilities',
        description: 'World-class amenities, including:\n• Dedicated changing rooms\n• Showers and drinking water facilities\n• First aid assistance for safety and well-being\n• Secure parking for a hassle-free experience',
    },
    {
      imgSrc: 'https://machaxidev.blob.core.windows.net/frontend-machaxi/sb4.png',
      title: 'Health & Fitness Benefits',
      description: 'Swimming provides a full-body workout, enhances endurance, and boosts cardiovascular health. It’s low-impact, stress-relieving, and ideal for all fitness levels.',
  },  
];
useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);

const goToNext = () => {
  setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderData.length);
};

const goToPrev = () => {
  setCurrentIndex((prevIndex) => (prevIndex - 1 + sliderData.length) % sliderData.length);
};

const pauseAutoSlide = () => {
  setIsAutoSlidePaused(true);
  setTimeout(() => setIsAutoSlidePaused(false), 3000); // Resume after 3 seconds
};


const getVisibleItems = () => {
  const visibleItems = [];
  for (let i = 0; i < 3; i++) {
    visibleItems.push(sliderData[(currentIndex + i) % sliderData.length]);
  }
  return visibleItems;
};


useEffect(() => {
  if (isAutoSlidePaused) return;
  const interval = setInterval(goToNext, 3000);
  return () => clearInterval(interval);
}, [isAutoSlidePaused, currentIndex]); // Added currentIndex to prevent sync issues



useEffect(() => {
  if (isMobile && sliderRef.current) {
    const slider = sliderRef.current;
    const cardWidth = slider.children[0].offsetWidth;
    slider.scrollTo({
      left: currentIndex * cardWidth,
      behavior: 'smooth',
    });
  }
}, [currentIndex, isMobile]);
useEffect(() => {
  const slider = sliderRef.current;
  if (!slider) return;

  let isScrolling;

  const handleScroll = () => {
    setIsAutoSlidePaused(true); // Pause auto-slide when user scrolls manually
    clearTimeout(isScrolling);
    isScrolling = setTimeout(() => {
      setIsAutoSlidePaused(false); // Resume auto-slide after user stops scrolling
    }, 3000);
  };

  slider.addEventListener('scroll', handleScroll);
  return () => slider.removeEventListener('scroll', handleScroll);
}, []);

// Touch event handlers for manual scrolling
const touchStartX = useRef(0);
const touchEndX = useRef(0);

const handleTouchStart = (e) => {
  touchStartX.current = e.touches[0].clientX;
};

const handleTouchMove = (e) => {
  touchEndX.current = e.touches[0].clientX;
};

const handleTouchEnd = () => {
  if (touchStartX.current - touchEndX.current > 50) {
    goToNext(); // Swipe left
    pauseAutoSlide();
  } else if (touchEndX.current - touchStartX.current > 50) {
    goToPrev(); // Swipe right
    pauseAutoSlide();
  }
};
useEffect(() => {
  initFacebookPixel(); // Track page view when this page loads
}, []);
return (
  <div className="program-details-container">
    <div className="floating-button"></div>
    <h2 className="program-title">PROGRAM BENEFITS</h2>
    {isMobile ? (
      <div
        className="mobile-slider-container"
        ref={sliderRef}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {sliderData.map((card, index) => (
          <div key={index} className="slider-card">
            <div className="card-image-container">
              <img src={card.imgSrc} alt={card.title} className="slider-image" />
            </div>
            <div className="slider-text">
              <h3 className="slider-title">{card.title}</h3>
              <p className="description">{card.description}</p>
            </div>
          </div>
        ))}
      </div>
    ) : (
      // Desktop view: Carousel
      <div
        className="slider-container"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <button className="nav-button prev" onClick={() => { goToPrev(); pauseAutoSlide(); }}>
          <span className="arrow">&larr;</span>
        </button>

        <div className="cards-container">
          {getVisibleItems().map((card, index) => (
            <div key={index} className="slider-card">
              <div className="card-image-container">
                <img
                  src={card.imgSrc}
                  alt={card.title}
                  className="slider-image"
                />
              </div>
              <div className="slider-text">
                <h3 className="slider-title">{card.title}</h3>
                <p className="description">{card.description}</p>
              </div>
            </div>
          ))}
        </div>

        <button className="nav-button next" onClick={() => { goToNext(); pauseAutoSlide(); }}>
          <span className="arrow">&rarr;</span>
        </button>
      </div>
    )}

    {/* Indicators for desktop view */}
    {!isMobile && (
      <div className="indicator-container">
        {sliderData.map((_, index) => (
          <span
            key={index}
            className={`indicator ${index === currentIndex ? 'active' : ''}`}
            onClick={() => { setCurrentIndex(index); pauseAutoSlide(); }}
          />
        ))}
      </div>
    )}
  </div>
);
};

export default ProgramDetails;